import { graphql } from '@/gql';
import type { UpdateCallerSubscriptionWithRefundMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateCallerSubscriptionWithRefund = async ({
  callerId,
  planName,
  notes,
  deactivationReason,
  refundType,
  refundAmount,
  refundAsCredits,
}: UpdateCallerSubscriptionWithRefundMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      planName,
      refundType,
      notes,
      deactivationReason,
      refundAmount,
      refundAsCredits,
    },
    mutation: graphql(`
      mutation UpdateCallerSubscriptionWithRefund(
        $callerId: String!
        $planName: String
        $refundType: String!
        $refundAmount: Float
        $notes: String!
        $refundAsCredits: Boolean
        $deactivationReason: String
      ) {
        updateCallerSubscriptionWithRefund(
          callerId: $callerId
          planName: $planName
          refundType: $refundType
          refundAmount: $refundAmount
          notes: $notes
          refundAsCredits: $refundAsCredits
          deactivationReason: $deactivationReason
        ) {
          id
          callerId
          planName
          nextPlanName
          periodStartAt
          periodEndAt
          expectedPeriodEndAt
          isTrial
          transactionId
          timePlanSuspendPeriodStartDate
          timePlanSuspendPeriodEndDate
        }
      }
    `),
  });

  return response.data?.updateCallerSubscriptionWithRefund;
};
